import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import CustomImageUpload from "../../component/CustomImageUpload";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const addEndpoint = ApiEndpoints.locpage.Create;
export default function AddLocationPage() {
  const navigate = useNavigate();
  const [previews, setPreviews] = useState({
    header_menu_image: null,
    hero_banner: null,
    slider_image1: null,
    slider_image2: null,
    slider_image3: null,
    slider_image4: null,
    testimonial_image1: null,
    testimonial_image2: null,
    testimonial_image3: null,
    testimonial_image4: null,
  });

  const [postData, setPostData] = useState({
    location_page_slug: "",
    page_city: "",
    page_title: "",
    stat1: "",
    stat_description1: "",
    stat2: "",
    stat_description2: "",
    stat3: "",
    stat_description3: "",
    stat4: "",
    stat_description4: "",
    map_url: "",
    section1_title: "",
    section1_description: "",
    testimonial_title1: "",
    testimonial_image1: "",
    testimonial_description1: "",
    testimonial_author1: "",
    testimonial_author_description1: "",
    testimonial_title2: "",
    testimonial_image2: "",
    testimonial_description2: "",
    testimonial_author2: "",
    testimonial_author_description2: "",
    testimonial_title3: "",
    testimonial_image3: "",
    testimonial_description3: "",
    testimonial_author3: "",
    testimonial_author_description3: "",
    status: "",
    hero_banner: "",
    header_menu_image: "",
    testimonial_image4: "",
    testimonial_title4: "",
    testimonial_description4: "",
    testimonial_author4: "",
    testimonial_author_description4: "",
    slider_image1: "",
    slider_image2: "",
    slider_image3: "",
    slider_image4: "",
    date: new Date(),

  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      const file = files[0];
      // Update the previews state
      setPreviews((prev) => ({
        ...prev,
        [name]: URL.createObjectURL(file),
      }));

      // Update the postData state
      setPostData((prev) => ({
        ...prev,
        [name]: file,
      }));
    } else {
      // For non-file inputs, update the postData state directly
      setPostData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleEditorChange = (key, data) => {
    setPostData((prevState) => ({
      ...prevState,
      [key]: data,
    }));
  };


  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    for (const [key, value] of Object.entries(postData)) {
      if (key !== "status" && (value === "" || value === null)) {
        toast.error(`The field "${key}" is mandatory.`);
        return;
      }
    }

    const formData = new FormData();
    Object.entries(postData).forEach(([key, value]) => {
      formData.append(key, value);
    });

    try {
      const response = await ApiRequest("POST", addEndpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success(response.message);
      navigate("/location-page");
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const pagename = {
    name: 'Location Management',
    user: 'Admin',
    innerpage: 'Location Management / Location / Add Location'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-content-page">
        <form id="blogEdit" onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-4">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label> Header Menu  Image  (604 × 584 px)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="header_menu_image"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.header_menu_image}
                  />
                </div>
              </div>



              <div className="col-lg-8">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label> Hero Banner  (1920 × 804 px)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="hero_banner"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.hero_banner}
                  />
                </div>
              </div>


              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>  Page Title <small>*</small>  </label>
                  </div>
                  <input onChange={handleChange} name="page_title" type="text" className="form-control" placeholder="Page Title " />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                     <label>slug<small>*</small> (add prefix "locations-" in slug)</label>
                  </div>
                  <input onChange={handleChange} name="location_page_slug" type="text" className="form-control" placeholder="Page  Slug" />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>  Form Heading <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section1_title" type="text" className="form-control" placeholder="Form Heading" />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>  Form Description <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section1_description" type="text" className="form-control" placeholder="Form Description " />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>  City Name <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="page_city" type="text" className="form-control" placeholder="City Name" />
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              {[1, 2, 3, 4].map((num) => (
                <div className="col-lg-3" key={num}>
                  <div className="add-page-inputs">
                    <div className="label-wrap-add">
                      <label>Counter Number{num} <small>*</small>  </label>
                    </div>
                    <input onChange={handleChange} name={`stat${num}`} type="text" className="form-control" placeholder={`Counter Heading${num}`} />
                  </div>

                  <div className="add-page-inputs">
                    <div className="label-wrap-add">
                      <label>  Counter Description{num} <small>*</small>  </label>
                    </div>
                    <input onChange={handleChange} name={`stat_description${num}`} className="form-control" placeholder={`Counter Description${num}`} />
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Iframe Url <small>*</small>   </label>
                  </div>
                  <input onChange={handleChange} name="map_url" className="form-control" placeholder="Iframe Url" />
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap multiple-image-area">
            <div className="row">

              {[1, 2, 3, 4].map((num) => (
                <div className="col-lg-6" key={num}>
                  <div className="add-page-inputs input-add-image">
                    <div className="label-wrap-add">
                      <label> Slider Image{num} <small>*</small></label>
                    </div>
                    <CustomImageUpload name={`slider_image${num}`}
                      // maxSize={100 * 1024} // 320KB
                      acceptedFormats={[".webp"]}
                      onImageChange={handleChange}
                      imagePreview={previews[`slider_image${num}`]}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>


          {[1, 2, 3, 4].map((num) => (
            <div className="add-content-wrap" key={num}>
              <div className="row">
                {/* Left column */}
                <div className="col-lg-6">
                  <div className="add-page-inputs">
                    <div className="label-wrap-add">
                      <label> Testimonial Title {num} <small>*</small></label>
                    </div>
                    <input
                      onChange={handleChange}
                      name={`testimonial_title${num}`}
                      type="text"
                      className="form-control"
                      placeholder={`Testimonial Title ${num}`}
                    />
                  </div>

                  <div className="add-page-inputs">
                    <div className="label-wrap-add">
                      <label> Testimonial Description {num} <small>*</small></label>
                    </div>
                    <textarea rows={5} onChange={handleChange} name={`testimonial_description${num}`} className="form-control" placeholder={`Description ${num}`} />

                  </div>
                </div>

                {/* Middle column */}
                <div className="col-lg-6">
                  <div className="add-page-inputs">
                    <div className="label-wrap-add">
                      <label> Testimonial Author {num} <small>*</small></label>
                    </div>
                    <input
                      onChange={handleChange}
                      name={`testimonial_author${num}`}
                      type="text"
                      className="form-control"
                      placeholder={`Author ${num}`}
                    />
                  </div>

                  <div className="add-page-inputs">
                    <div className="label-wrap-add">
                      <label> Testimonial Author Designation {num} <small>*</small></label>
                    </div>
                    <input
                      onChange={handleChange}
                      name={`testimonial_author_description${num}`}
                      className="form-control"
                      placeholder={`Author Designation ${num}`}
                    />
                  </div>
                </div>

                {/* Right column */}
                <div className="col-lg-12">
                  <div className="add-page-inputs input-add-image">
                    <div className="label-wrap-add">
                      <label> Testimonial Image {num} <small>*</small></label>
                    </div>
                    <CustomImageUpload
                      name={`testimonial_image${num}`}
                      acceptedFormats={[".webp"]}
                      onImageChange={handleChange}
                      imagePreview={previews[`testimonial_image${num}`]}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}



        </form>

        {/* Submit Button */}
        <button type="submit" form="blogEdit" className="default-btn" >  Publish <span></span>   </button>
      </div>
    </>
  );
}

